import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Popover as ReactPopover, PopoverBody} from 'reactstrap';

const Popover = (props) => {
  return (
    <ReactPopover placement={props.placement} isOpen={props.popoverOpen} target={props.target} toggle={props.toggle} {...props}>
      {props.hideCloseBtn ? null : (
        <div className='popover-btn-close'>
          <Image src={require('./images/x.svg')} alt='סגור' onClick={props.closePopover} className='popover-close-img' />
        </div>
      )}

      <div className='popover-text-holder'>
        <PopoverBody>{props.text}</PopoverBody>
      </div>
    </ReactPopover>
  );
};
export default Popover;
